export default __webpack_public_path__ + "static/media/koala@2x.7cebf84e.png";